import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import { injectIntl, defineMessages } from 'react-intl';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as templateActions from 'modules/template';

import { ExamTemplateCopy } from 'components';

class CtExamTemplateCopy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //copyVisible: false,
      coping: false,
      targetServiceNo: 0,
      errorMessage: ''
    };
  }

  onInitErrorMessage = e => {
    const { formatMessage } = this.props.intl;
    // 빈값이거나 숫자이거나
    if (e.target.value === '' || !!Number(e.target.value)) {
      this.setState({ errorMessage: '' });
    } else if (e.target.value.substring(0, 1) === '0') {
      this.setState({
        errorMessage: defineMessages(formatMessage({ id: 'vali_5', defaultMessage: '값을 입력하세요.' }))
      });
    } else if (!Number(e.target.value)) {
      this.setState({
        errorMessage: defineMessages(
          formatMessage({ id: 'CtExamTemplateCopy_1', defaultMessage: '숫자만 가능합니다.' })
        )
      });
    }
  };

  recordServiceNo = value => {
    const serviceNo = Number(value);
    if (serviceNo && this.state.targetServiceNo !== serviceNo) {
      this.setState({ targetServiceNo: serviceNo });
    }
  };

  copyTemplate = async () => {
    this.setState({ coping: true });

    const { targetServiceNo } = this.state;
    const { isAuth, mountCopyModal, templateInfo: { serviceNo, templateNo, serviceTemplateNo } } = this.props;

    const params = {};
    let isOk = true;
    let errorMessage = '';
    if (isAuth === 2 && targetServiceNo) {
      params.serviceNo = targetServiceNo;
    }
    if (serviceTemplateNo) {
      params.serviceTemplateNo = serviceTemplateNo;
    } else if (templateNo) {
      params.examTemplateNo = templateNo;
    } else {
      // 오류
      isOk = false;
    }

    if (isOk) {
      try {
        const { TemplateActions } = this.props;
        const respObj = await TemplateActions.copyTemplate(params);
        if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
          // 성공
          if (!!respObj.data.list) {
            // 새로고침
            TemplateActions.reloadTemplate();
            mountCopyModal();
            // 서비스 넘버 에러
          } else if (!!respObj.data.error && !!respObj.data.error[0].errInfo) {
            if (respObj.data.error[0].errInfo === 'Invalid ServiceNo') {
              errorMessage = respObj.data.error[0].errInfo;
            }
          }
        } else {
          // 응답 오류
          console.log('실패');
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log('copyTemplate isOk fail!');
    }

    this.setState({ errorMessage: errorMessage, coping: false });
  };

  render() {
    const { coping } = this.state;
    const { isAuth, templateInfo, mountCopyModal } = this.props;
    const { onInitErrorMessage, recordServiceNo, copyTemplate } = this;

    return (
      <ExamTemplateCopy
        isAuth={isAuth}
        coping={coping}
        errorMessage={this.state.errorMessage}
        templateInfo={templateInfo}
        copyTemplate={copyTemplate}
        onInitErrorMessage={onInitErrorMessage}
        recordServiceNo={recordServiceNo}
        handleOnToggleCopyModal={mountCopyModal}
      />
    );
  }
}

CtExamTemplateCopy.propTypes = {};
CtExamTemplateCopy.defaultProps = {};

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch)
});

export default connect(undefined, mapDispatchToProps)(injectIntl(CtExamTemplateCopy));



// WEBPACK FOOTER //
// ./src/script/containers/examTemplate/CtExamTemplateCopy.js